export const slotTargetValue = {
  allSlot: "all_slot",
  customSlot: "custom_slot",
  selectedSlot: "selected_slot",
};

export const slotTargetLabel = {
  [slotTargetValue.allSlot]: "All Slot",
  [slotTargetValue.customSlot]: "Custom Slot",
  [slotTargetValue.selectedSlot]: "Selected Slot",
};

export const slotTargetDropdown = [
  slotTargetValue.allSlot,
  slotTargetValue.customSlot,
  slotTargetValue.selectedSlot,
].map((value) => ({
  display: slotTargetLabel[value],
  value: value,
  disabled: false,
}));
